import ControlState from '../Shared/controlState';
import JSONSchema7Properties from '../Shared/jSONSchema7Properties';

export default (controls: ControlState[]) => {
  const modifiedControl = controls.map((control: ControlState, index) => {
    const newProperties = control.schema?.properties as JSONSchema7Properties;

    if (newProperties.order) {
      newProperties.order = {
        $id: newProperties.order.$id,
        type: newProperties.order.type,
        default: index
      };
    }

    return {
      ...control,
      schema: {
        ...control.schema,
        properties: newProperties
      }
    };
  });

  const newSchemaProperties = new Object() as JSONSchema7Properties;

  for (const c in modifiedControl) {
    newSchemaProperties[modifiedControl[c].id] = modifiedControl[c].schema;
  }

  return newSchemaProperties;
};
